/**
 * Filter data passed as parameter based on key and filterValues from the filter parameter
 * @param data The data to filter
 * @param filter The object with key and filterValues props that define how the data must be filtered
 */
export const filterData = <A extends Record<string, any>>(
  data: A[],
  filter: { key: string; filterValues?: string | string[] }
): A[] => {
  const { key, filterValues } = filter
  if (!key || !filterValues || !data || data.length === 0 || typeof data[0][key] === 'undefined')
    return data
  // Conditions if filterValues is an array
  if (Array.isArray(filterValues)) {
    if (filterValues.length === 0) return data
    return data.filter((elt) => {
      // Check if one of the values in filters is equal to the elt[key]
      return filterValues.some((value) => elt[key].toLowerCase() === value.toLowerCase())
    })
  }
  return data.filter((elt) => elt[key].toLowerCase().includes(filterValues.toLowerCase()))
}

export default filterData
